import React, { Component } from 'react';
import Parser from 'html-react-parser';
import { DocumentIcon, ArrowIcon, ListIcon, GearIcon, TemperatureIcon, PackageIcon, LocationIcon } from './SVGIcons';

import OffcanvasForm from './OffcanvasForm';
import ImageSlider from './ImageSlider';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showCallForm: false,
      callFormTitle: "Запросить коммерческое предложение"
    };
  }

  // Метод для открытия формы заказа звонка
  openCallForm = ( title ) => {
    this.setState({ callFormTitle: title, showCallForm: true });
  };

  // Метод для закрытия формы заказа звонка
  closeCallForm = () => {
    this.setState({ showCallForm: false });
  };

  // Обработчик успешной отправки
  handleFormSuccess = (message) => {
    // Закрываем Offcanvas меню
    this.props.hide();
    // Показываем сообщение об успехе
    if (this.props.onSuccess) {
      this.props.onSuccess(message);
    }
  };

  // Обработчик ошибки отправки
  handleFormError = (error) => {
    if (this.props.onError) {
      this.props.onError(error);
    }
  };

  render() {

    const { showCallForm, callFormTitle } = this.state
    const data = this.props?.data || {}
    const product = data?.product || {}
    const brands = product?.brands || {}

    // Собираем массив непустых изображений
    const productImages = [
      product?.image,
      product?.image2,
      product?.image3,
      product?.image4,
      product?.image5,
      product?.image6,
    ].filter(img => img && img.trim() !== '');

    return (
      <>
        <div className='mt-[40px] w-full'>
          <div className='container'>
            <div className='flex items-start justify-start w-full gap-[20px] md:gap-[40px] flex-wrap lg:flex-nowrap'>
              <div className='flex-none w-[440px] max-w-full hidden md:block'>
                <ImageSlider images={productImages} alt={data?.pagetitle} />
              </div>
              <div className='flex-auto'>
                <div className='uppercase tracking-tight text-title text-ptblack leading-none'>{Parser(data?.h1 || data?.pagetitle)}</div>
                <div className='flex-none w-full mt-[20px] md:hidden'>
                  <ImageSlider images={productImages} alt={data?.pagetitle} />
                </div>
                <div className='flex items-center gap-[40px] mt-[20px] md:mt-[40px] flex-wrap'>
                  <div className='flex items-center gap-[8px] flex-wrap w-full xl:w-auto flex-col xl:flex-row'>
                    <div onClick={() => this.openCallForm("Запросить коммерческое предложение")} className='w-full xl:w-auto cursor-pointer bg-[#BC0005] duration-300 ease-in-out hover:bg-[#930105] px-[22px] h-[48px] flex-none flex items-center justify-center rounded-[14px] gap-[12px] text-white'>
                      <DocumentIcon width={16} height={16} stroke="currentColor" />
                      <div className='text-base'>Запросить КП</div>
                    </div>
                    <div onClick={() => this.openCallForm("Уточнить цену")} className='w-full xl:w-auto cursor-pointer bg-[#F6F7F8] duration-300 ease-in-out hover:bg-[#DBE7F3] px-[22px] h-[48px] flex-none flex items-center justify-center rounded-[14px] gap-[12px] text-[#001553]'>
                      <div className='text-base'>Уточнить цену</div>
                      <ArrowIcon width={16} height={16} stroke="currentColor" />
                    </div>
                  </div>
                  <div className='text-ptgray text-base leading-none text-center md:text-left w-full md:w-auto max-w-full md:max-w-[270px]'>Согласуем цену и условия под объём, тару и регион поставки.</div>
                </div>
                <div className='mt-[20px] bg-[#F6F7F8] p-[20px] rounded-[14px]'>
                  <div className='flex items-center justify-between gap-[20px] flex-wrap'>
                    {product?.type != `` &&
                      <div className='leading-none'>
                        <div className='flex items-center gap-[8px] text-cardTitle text-ptblack uppercase'>
                          <div className='text-[#001553]'>
                            <ListIcon width={16} height={16} stroke="currentColor" />
                          </div>
                          <div>тип</div>
                        </div>
                        <div className='mt-[8px] text-base text-ptgray'>{product?.type}</div>
                      </div>
                    }
                    <div className='w-px h-[39px] bg-[#1414141A]' />
                    {product?.class != `` &&
                      <div className='leading-none flex-auto md:flex-none'>
                        <div className='flex items-center gap-[8px] text-cardTitle text-ptblack uppercase'>
                          <div className='text-[#001553]'>
                            <GearIcon width={16} height={16} stroke="currentColor" />
                          </div>
                          <div>Класс</div>
                        </div>
                        <div className='mt-[8px] text-base text-ptgray'>{product?.class}</div>
                      </div>
                    }
                    <div className='w-px h-[39px] bg-[#1414141A] hidden md:block' />
                    <div className='w-full h-px bg-[#1414141A] md:hidden' />
                    {product?.temp != `` &&
                      <div className='leading-none flex-auto'>
                        <div className='flex items-center gap-[8px] text-cardTitle text-ptblack uppercase'>
                          <div className='text-[#001553]'>
                            <TemperatureIcon width={16} height={16} stroke="currentColor" />
                          </div>
                          <div>Температура защиты</div>
                        </div>
                        <div className='mt-[8px] text-base text-ptgray'>{product?.temp}</div>
                      </div>
                    }
                  </div>
                  <div className='w-full h-px bg-[#1414141A] mt-[20px]' />
                  <div className='flex items-center justify-between gap-[20px] mt-[20px] flex-wrap'>
                    {product?.package != `` &&
                      <div className='leading-none'>
                        <div className='flex items-center gap-[8px] text-cardTitle text-ptblack uppercase'>
                          <div className='text-[#001553]'>
                            <PackageIcon width={16} height={16} stroke="currentColor" />
                          </div>
                          <div>Фасовка</div>
                        </div>
                        <div className='mt-[8px] text-base text-ptgray'>{product?.package}</div>
                      </div>
                    }
                    <div className='w-full h-px bg-[#1414141A] md:hidden' />
                    <div className='w-px h-[39px] bg-[#1414141A] hidden md:block' />
                    {product?.target != `` &&
                      <div className='leading-none flex-auto'>
                        <div className='flex items-center gap-[8px] text-cardTitle text-ptblack uppercase'>
                          <div className='text-[#001553]'>
                            <LocationIcon width={16} height={16} stroke="currentColor" />
                          </div>
                          <div>Назначение</div>
                        </div>
                        <div className='mt-[8px] text-base text-ptgray'>{product?.target}</div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
            <div className='mt-[40px] bg-[#F6F7F8] p-[20px] rounded-[14px] text-base text-ptgray page_content'>
              {Parser(data?.content || '')}
            </div>
            
            {product?.line == 'East Dragon' && brands[1] != '' &&
              <>
                {/* Адаптивная сетка брендов - большое фото слева, остальные справа в сетке 2x3 */}
                <div className='flex flex-col md:flex-row w-full mt-[40px] gap-[10px] sm:gap-[20px]'>
                  {/* Левое большое изображение */}
                  <div className='w-[476px] flex-shrink-0 hidden sm:block'>
                    <img 
                      src={brands[1]}
                      alt='brand' 
                      className='w-full h-auto rounded-[14px] object-cover'
                      style={{ height: 'auto', maxHeight: '172px' }}
                    />
                  </div>
                  
                  {/* Правая часть с сеткой 2x3 */}
                  <div className='flex-1'>
                    {/* Первая строка - 2 изображения */}
                    <div className='grid grid-cols-2 gap-[10px] sm:gap-[20px]'>
                      <div className='w-full bg-[#f5f7f9] rounded-[12px] flex items-center justify-center'>
                        <img 
                          src={brands[2]}
                          alt='brand' 
                          className='w-full h-auto rounded-[14px] object-contain bg-[#F6F7F8]'
                          style={{ maxHeight: '96px' }}
                        />
                      </div>
                      <div className='w-full bg-[#f5f7f9] rounded-[12px] flex items-center justify-center'>
                        <img 
                          src={brands[3]}
                          alt='brand' 
                          className='w-full h-auto rounded-[14px] object-contain bg-[#F6F7F8]'
                          style={{ maxHeight: '96px' }}
                        />
                      </div>
                    </div>
                    
                    {/* Вторая строка - 3 изображения */}
                    <div className='grid grid-cols-3 gap-[10px] sm:gap-[20px] mt-[10px] sm:mt-[20px]'>
                      <div className='w-full bg-[#f5f7f9] rounded-[12px] flex items-center justify-center'>
                        <img 
                          src={brands[4]}
                          alt='brand' 
                          className='w-full h-auto rounded-[14px] object-contain bg-[#F6F7F8]'
                          style={{ maxHeight: '65px' }}
                        />
                      </div>
                      <div className='w-full bg-[#f5f7f9] rounded-[12px] flex items-center justify-center'>
                        <img 
                          src={brands[5]}
                          alt='brand' 
                          className='w-full h-auto rounded-[14px] object-contain bg-[#F6F7F8]'
                          style={{ maxHeight: '65px' }}
                        />
                      </div>
                      <div className='w-full bg-[#f5f7f9] rounded-[12px] flex items-center justify-center'>
                        <img 
                          src={brands[6]}
                          alt='brand' 
                          className='w-full h-auto rounded-[14px] object-contain bg-[#F6F7F8]'
                          style={{ maxHeight: '66px' }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className='w-full flex-shrink-0 sm:hidden'>
                    <img 
                      src={brands[1]}
                      alt='brand' 
                      className='w-full h-auto rounded-[14px] object-cover'
                      style={{ height: 'auto' }}
                    />
                  </div>
                </div>
                <div className='mt-[20px] flex justify-start w-full'>
                  <div className='bg-[#F6F7F8] p-[20px] rounded-[14px] text-base text-ptgray page_content'>
                    <span className='text-ptblack'>Логотипы приведены для ориентира.</span> Совместимость уточняйте по требованиям системы охлаждения.
                  </div>
                </div>
              </>
            }
          </div>
        </div>

        {/* Форма заказа звонка */}
        <OffcanvasForm
          show={showCallForm}
          hide={this.closeCallForm}
          formTitle={callFormTitle}
          formText="Укажите контактные данные и количество — подготовим КП по выбранному товару. Если нужна доставка, добавьте адрес: рассчитаем условия и сроки под ваш регион."
          productName={data?.pagetitle} // Можно передать название товара, если нужно
          onSuccess={this.handleFormSuccess}
          onError={this.handleFormError}
        />
      </>
    );
  }
}

export default App;